import * as React from 'react';
import './calendar-day.css';

export class CalendarDayPlaceholder extends React.Component {
    render() {
        return <div styleName='container-empty' />;
    }
}
